/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_EmptyInputs */

const en_admin_funnel_empty = /** @type {(inputs: Admin_Funnel_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data yet`)
};

/**
* | output |
* | --- |
* | "No data yet" |
*
* @param {Admin_Funnel_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_empty = /** @type {((inputs?: Admin_Funnel_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_empty(inputs)
});
export { admin_funnel_empty as "admin.funnel.empty" }